import "./badge.scss";

export default function Badge({ label, variant, size = "M" }) {
    return (
        <span className={`badge badge--${variant} badge--size-${size}`}>
            {label}
        </span>
    );
}
